import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Product } from '@b2b/features/product/core/utilities/product.model';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { ProductCardComponent } from '@b2b/components/product/product-card/product-card.component';

@Component({
  selector: 'product-card-modal',
  templateUrl: './product-card-modal.component.html',
  imports: [ProductCardComponent],
})
export class ProductCardModalComponent {
  private readonly modalService = inject(ModalService<{ product: Product }>);

  private activeModal = toSignal(this.modalService.getActiveModal());

  product = computed(() => this.activeModal()?.data?.product ?? null);
}
